
export default {
  name: 'section-directions',
  data () {
    return {
      list: [
        {
          from: 'SLY',
          to: 'TJM',
          price: '11 300',
        },
        {
          from: 'NUX',
          to: 'MRV',
          price: '16 500',
        },
        {
          from: 'MOW',
          to: 'NUX',
          price: '10 600',
        },
        {
          from: 'SLY',
          to: 'MOW',
          price: '17 500',
        },
      ],
    };
  },
};
